/* istanbul ignore file */
import React from 'react';
import Select, { MultiValue } from 'react-select';
import BaseInputLayout, {
  COMMON_INPUT_LAYOUT_DEFAULT_PROPS,
  getBaseInputLayoutProps,
  getCommonInputProps,
} from './BaseInputLayout';
import { Option, LoadMultiSelectInputLayoutProps, LoadMultiSelectInputLayoutType } from 'framework/form';
import { IndicatorsContainer } from './DropdownComponents';
import getDropdownLayoutCommonProps from './dropdownLayoutHelper';
import { useTheme } from '@mui/material/styles';

const LoadMultiSelectInputLayout: LoadMultiSelectInputLayoutType = ({
  placeholder,
  onChangeCallback = () => {},
  noOptionsMessage,
  value: initialValue,
  options = [],
  menuPortalTarget = document.body,
  ...otherProps
}: LoadMultiSelectInputLayoutProps) => {
  const props = {
    ...COMMON_INPUT_LAYOUT_DEFAULT_PROPS,
    ...otherProps,
  };
  const theme = useTheme();
  const { selectClassName, styles, classNamePrefix } = getDropdownLayoutCommonProps(props, theme);

  return (
    <BaseInputLayout {...getBaseInputLayoutProps(props)}>
      <Select
        {...getCommonInputProps(props)}
        value={initialValue}
        className={selectClassName}
        classNamePrefix={classNamePrefix}
        isMulti={true as any}
        menuPortalTarget={menuPortalTarget}
        placeholder={placeholder}
        onChange={(value: MultiValue<Option>) => {
          onChangeCallback({ target: { value } });
        }}
        noOptionsMessage={noOptionsMessage}
        isClearable
        styles={styles}
        options={options}
        components={{
          IndicatorsContainer,
          ...props?.components,
        }}
      />
    </BaseInputLayout>
  );
};

export default LoadMultiSelectInputLayout;
